// libs
import React from 'react';

import { Box } from '@lyearn/ui';

// component
import * as ContentList from '../ContentList';
// types
import { BodyProps } from './types';

function Body(props: BodyProps) {
  const { itemRenderer, className, listClassName, withPagination = true, isFetchingMore } = props;

  return (
    <Box className={className}>
      <ContentList.Items
        className={listClassName}
        renderer={itemRenderer}
        withPagination={withPagination}
      />
    </Box>
  );
}

export default Body;
